










import { Component, Prop, Vue } from 'vue-property-decorator';
import ProgressBar from 'progressbar.js';

@Component({
  mixins: [],
  components: {},
})
export default class ProgressLineComponent extends Vue {
  @Prop({ default: 'progress-bar-component' })
  elementId: string;

  @Prop({ default: 'progress' })
  classNames: string;

  @Prop({ default: '#4CD964' })
  color: string;

  @Prop({ default: '#0b4f69' })
  trailColor: string;

  @Prop({ default: 4 })
  barHeight: number;

  @Prop({ default: 150 })
  duration: number;

  @Prop({ default: 0 })
  pctComplete: string;

  progressBar: any;

  mounted() {
    this.$nextTick(() => {
      this.progressBar = new ProgressBar.Line(`#${this.elementId}`, {
        color: this.color,
        trailColor: this.trailColor,
        duration: this.duration,
        easing: 'linear',
        strokeWidth: 5,
      });
      this.progressBar.set(0);
      this.progressBar.animate(parseInt(this.pctComplete, 10) / 100);
      window.setTimeout(() => { this.progressBar.set(parseInt(this.pctComplete, 10) / 100); }, this.duration);
    });
  }

  updated() {
    if (this.progressBar) {
      this.progressBar.animate(parseInt(this.pctComplete, 10) / 100);
      window.setTimeout(() => { this.progressBar.set(parseInt(this.pctComplete, 10) / 100); }, this.duration);
    }
  }
}
